import { CIcon } from '~/icons/types'

export const ciBmxBike: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M20.032 11.467a3.13 3.13 0 0 0-.37.037l-.668-1.873-1.124-3.155h.684a.487.487 0 0 0 .448-.678L17.77 2.916a.487.487 0 1 0-.896.382l.943 2.205h-.638a.487.487 0 0 0-.458.65l.732 2.057-8.679 1.128-.705-1.62.575.002h.001a.487.487 0 0 0 .002-.973l-2.261-.008h-.002a.487.487 0 0 0-.001.974l.622.002.946 2.171-1.865 2.06a3.165 3.165 0 0 0-1.662-.479 3.197 3.197 0 1 0 3.164 3.526h1.618a1.262 1.262 0 0 0 1.048.583 1.284 1.284 0 0 0 1.277-1.195l6.745-3.862.441 1.238a3.182 3.182 0 1 0 1.315-.29ZM9.442 13.31a1.267 1.267 0 0 0-.419.71H7.556a3.173 3.173 0 0 0-.729-1.442l1.55-1.712Zm-3.272-.006a2.203 2.203 0 0 1 .37.715H5.523Zm-1.746 3.582a2.223 2.223 0 1 1 0-4.445 2.196 2.196 0 0 1 .993.244l-1.353 1.494a.487.487 0 0 0 .36.814h2.19a2.22 2.22 0 0 1-2.19 1.893Zm6.789-3.444a1.275 1.275 0 0 0-.835-.42l-1.2-2.755 8.583-1.116.173.443Zm8.819 3.444a2.217 2.217 0 0 1-.985-4.205l.708 1.99a.488.488 0 0 0 .46.323.47.47 0 0 0 .163-.029.487.487 0 0 0 .295-.621l-.677-1.9.036-.003a2.223 2.223 0 0 1 0 4.445Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'bmx-bike',
  type: 'thin'
}
